import { queryOptions, useMutation } from '@tanstack/react-query'
import { getSecret, createSecret, getSecrets, updateSecret, StudioSecret } from '@/features/secrets'

export const secretsQueries = {
  all: () => ['secrets'],
  lists: () => [...secretsQueries.all(), 'list'],
  list: (projectId: number) =>
    queryOptions({
      queryKey: [...secretsQueries.lists(), { projectId }],
      queryFn: () => getSecrets(projectId),
    }),
  details: () => [...secretsQueries.all(), 'detail'],
  detail: (projectId: number, secretId: number) =>
    queryOptions({
      queryKey: [...secretsQueries.all(), { projectId, secretId }],
      queryFn: () => getSecret(projectId, secretId),
    }),
}

export const useCreateSecret = (projectId: number) =>
  useMutation({
    mutationFn: (secret: StudioSecret) => createSecret(projectId, secret),
  })

export const useUpdateSecret = (projectId: number, secretId: number) =>
  useMutation({
    mutationFn: (secret: Partial<StudioSecret>) => updateSecret(projectId, secretId, secret),
  })
